<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on: tooltip }">
      <a-btn
        v-if="updateMeetingPermission"
        color="primaryDark"
        v-on="{ ...tooltip }"
        @click="getVotes()"
      >
        {{ $t("agenda.btnResult") }}</a-btn
      >
    </template>
    <span>{{ $t("agenda.tipResult") }}</span>
    <a-dialog v-model="isOpen" persistent width="90vw" max-width="75vw" scrollable>
      <v-card class="mx-auto">
        <v-toolbar color="primaryLight1" flat tile>
          <h4>
            {{ agendaName }} - &nbsp;<small>{{ topicName }}</small>
          </h4>
          <v-spacer></v-spacer>
          <CloseIcon @click="isOpen = false" />
        </v-toolbar>
        <v-card-text class="overflow-y-visible" style="padding: 0">
          <div class="pa-5" id="divId">
            <strong
              v-if="hasObjectionList.length > 0"
              class="justify-center red--text"
              style="display: flex; font-size: 22px"
              >{{ $t("agenda.lblInvalidResult") }}</strong
            >
            <strong style="font-size: 16px; color: #000000de">{{
              $t("agenda.hMeetingDetails")
            }}</strong>
            <table
              style="
                max-width: 100%;
                min-width: 100%;
                text-align: left;
                border: 1px solid lightgray;
                padding-left: 10px;
                font-size: 12px;
              "
              class="mt-2 meeting-table"
            >
              <tr>
                <th style="min-width: 100px; height: 20px; vertical-align: top">
                  {{ $t("title") }}
                </th>
                <td style="min-width: 20px; text-align: center">:</td>
                <td></td>
                <td>
                  <h4 style="word-break: break-word">
                    {{ getMeetingName(meetingObj.meetingName) }}
                  </h4>
                </td>
              </tr>
              <tr>
                <th>{{ $t("agenda.lblMeetingLocation") }}</th>
                <td style="text-align: center">:</td>
                <td></td>
                <td>
                  {{ meetingObj.location }}
                </td>
              </tr>
              <tr>
                <th>{{ $t("agenda.Scheduled") }}</th>
                <td style="text-align: center">:</td>
                <td></td>
                <td>
                  <strong>From &nbsp; </strong>
                  {{ getDay(meetingObj.scheduletStartTimeInUTC) }}&nbsp;
                  <strong> To &nbsp; </strong>
                  {{ getDay(meetingObj.scheduledEndTimeInUTC) }}
                </td>
              </tr>
              <tr
                v-if="meetingObj.startMeetingTime && meetingObj.endMeetingTime"
              >
                <th>{{ $t("agenda.Actual") }}</th>
                <td style="text-align: center">:</td>
                <td></td>
                <td>
                  <strong>From &nbsp; </strong>
                  {{ getDay(meetingObj.startMeetingTime) }}&nbsp;
                  <strong> To &nbsp; </strong>
                  {{ getDay(meetingObj.endMeetingTime) }}
                </td>
              </tr>
              <tr>
                <th>{{ $t("agenda.lblAttendees") }}</th>
                <td style="text-align: center">:</td>
                <td></td>
                <td>
                  <v-chip
                    small
                    class="pl-0 pr-2 mr-1 mt-1"
                    v-for="(item, index) in meetingObj.attendees"
                    :key="index"
                  >
                    <v-avatar class="ma-0 pa-0" size="30">
                      <img v-if="item.profilePhoto" :src="item.profilePhoto" />
                      <img v-else :src="noImage" />
                    </v-avatar>
                    <span style="padding-left: 10px">
                      <span v-if="item.firstName">
                        {{ item.firstName + " " + item.lastName }}
                      </span>
                      <span v-else>{{ item.email }}</span>
                    </span>
                  </v-chip>
                </td>
              </tr>
            </table>
          </div>
          <v-divider></v-divider>

          <v-card flat tile width="100%">
            <v-card-text style="padding: 20px !important">
              <v-row v-if="hasResult">
                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                  lg="4"
                  style="border-right: solid 1px lightgray"
                >
                  <approval-result-chart
                    :approvalStatusList="votingResponse"
                    :attendees="allPermittedVoterUsers"
                    :notActedVoteCount="notActedVoteCount"
                    chartType="vote"
                  ></approval-result-chart>
                </v-col>
                <v-col cols="12" sm="12" md="8" lg="8">
                  <div style="display: block">
                    <h4 style="color: #000000 !important;">
                      {{ $t("agenda.lblApproved") }}: {{ approvedList.length }}
                    </h4>
                    <h4 style="color: #000000 !important;">
                      {{ $t("agenda.lblRejected") }}: {{ rejectedList.length }}
                    </h4>
                    <h4 style="color: #000000 !important;">
                      {{ $t("agenda.lblAbstained") }}:
                      {{ abstainedList.length }}
                    </h4>
                    <h4 style="color: #000000 !important;" class="mb-2">
                        {{ $t("agenda.lblVoteNotActed") }}:
                        {{ notActedVoteCount.length }}
                      </h4>
                    <item-approval-result-section :results="allVotingResults"></item-approval-result-section>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="hasResult && auditorsConsentResult">
                <v-divider class="my-1"></v-divider>
              </v-row>
              <v-row v-if="auditorsConsentResult">
                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                  lg="4"
                  style="border-right: solid 1px lightgray"
                >
                  <approval-result-chart
                    :consentStatusList="votingResponse"
                    :attendees="allPermittedConsentUsers"
                    :notActedConsentCount="notActedConsentCount"
                    chartType="consent"
                  ></approval-result-chart>
                </v-col>
                <v-col cols="12" sm="12" md="8" lg="8">
                  <div style="display: block">
                    <h4 style="color: #000000 !important;">
                      {{ $t("agenda.lblNoObjection") }}:
                      {{ noObjectionList.length }}
                    </h4>
                    <h4 style="color: #000000 !important;">
                      {{ $t("agenda.lblhasObjection") }}:
                      {{ hasObjectionList.length }}
                    </h4>
                    <h4 style="color: #000000 !important;" class="mb-2">
                        {{ $t("agenda.lblVoteNotActed") }}:
                        {{ notActedConsentCount.length }}
                      </h4>
                    <item-approval-result-section :results="allConsentResults"></item-approval-result-section>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                  v-if="hasObjectionList.length > 0"
                >
                  <v-divider class="mb-1"></v-divider>
                  <h4>{{ $t("agenda.msgInvalidVotingResult") }}</h4>
                </v-col>
              </v-row>
              <v-row v-if="!hasResult && !auditorsConsentResult">
                <v-col cols="12" sm="12" md="12" lg="12" class="text-center">
                  <h3>
                    <strong>{{ $t("agenda.hRecordNotFound") }}</strong>
                  </h3>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider v-if="hasResult || auditorsConsentResult"></v-divider>
            <v-card-actions v-if="hasResult || auditorsConsentResult">
              <v-spacer></v-spacer>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    class="mr-2"
                    color="pageHeader"
                    text
                    @click.stop="generateSvg()"
                    v-if="hasResult || auditorsConsentResult"
                    ><v-icon small>mdi-file-export</v-icon>
                    {{ $t("agenda.tipExportPDF") }}
                  </v-btn>
                </template>
                <span>{{ $t("agenda.tipExportPDF") }}</span>
              </v-tooltip>
            </v-card-actions>
          </v-card>

          <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="false"
            :paginate-elements-by-height="1600"
            :filename="slugify"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="landscape"
            pdf-content-width="100%"
            :image="{
              type: 'jpeg',
              quality: 1,
            }"
            ref="html2Pdf"
          >
            <section slot="pdf-content" >
              <section class="pdf-item">
                <div
                  style="
                    text-align: center;
                    padding: 10px;
                    background-color: #2471a3;
                    color: white;
                  "
                >
                  <h2>{{ $t("agenda.hResolutionSummary") }}</h2>
                </div>
                <div
                  style="
                    text-align: left;
                    padding: 10px;
                    background-color: lightgray;
                  "
                >
                  <h3>
                    {{ agendaName }} - &nbsp;<small>{{ topicName }}</small>
                  </h3>
                </div>
                <div style="margin-left: 10px">
                  <strong
                    v-if="hasObjectionList.length > 0"
                    style="
                      display: flex;
                      font-size: 22px;
                      color: red;
                      justify-content: center;
                    "
                  >
                    {{ $t("agenda.lblInvalidResult") }}
                  </strong>
                  <strong>{{ $t("agenda.hMeetingDetails") }}</strong>
                  <table
                    style="
                      max-width: 100%;
                      min-width: 98%;
                      margin: 10px;
                      text-align: left;
                      border: 1px solid lightgray;
                      padding-left: 10px;
                    "
                  >
                    <tr class="avoid-page-break">
                      <th
                        style="
                          min-width: 100px;
                          height: 20px;
                          vertical-align: top;
                        "
                      >
                        {{ $t("title") }}
                      </th>
                      <td style="min-width: 20px; text-align: center">:</td>
                      <td></td>
                      <td>
                        <h4>{{ meetingObj.meetingName }}</h4>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t("agenda.lblMeetingLocation") }}</th>
                      <td style="text-align: center">:</td>
                      <td></td>
                      <td>
                        {{ meetingObj.location }}
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t("agenda.Scheduled") }}</th>
                      <td style="text-align: center">:</td>
                      <td></td>
                      <td>
                        <strong>From &nbsp; </strong>
                        {{ getDay(meetingObj.scheduletStartTimeInUTC) }}&nbsp;
                        <strong> To &nbsp; </strong>
                        {{ getDay(meetingObj.scheduledEndTimeInUTC) }}
                      </td>
                    </tr>
                    <tr v-if="meetingObj.startMeetingTime && meetingObj.endMeetingTime">
                      <th>{{ $t("agenda.Actual") }}</th>
                      <td style="text-align: center">:</td>
                      <td></td>
                      <td>
                        <strong>From &nbsp; </strong>
                        {{
                          getDay(meetingObj.startMeetingTime)
                        }}&nbsp; <strong> To &nbsp; </strong>
                        {{
                          getDay(meetingObj.endMeetingTime)
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t("agenda.lblAttendees") }}</th>
                      <td style="text-align: center">:</td>
                      <td></td>
                      <td>
                        <v-chip
                          small
                          class="pl-0 pr-1 mr-1 mt-1"
                          style="
                            padding-left: 0px;
                            padding-right: 10px;
                            margin-right: 5px;
                            margin-top: 5px;
                          "
                          v-for="(item, index) in meetingObj.attendees"
                          :key="index"
                        >
                          <v-avatar class="ma-0 pa-0" size="30">
                            <img
                              v-if="item.profilePhoto"
                              :src="item.profilePhoto"
                            />
                            <img v-else :src="noImage" />
                          </v-avatar>
                          <span style="padding-left: 10px">
                            <span v-if="item.firstName">
                              {{ item.firstName + " " + item.lastName }}
                            </span>
                            <span v-else>{{ item.email }}</span>
                          </span>
                        </v-chip>
                      </td>
                    </tr>
                  </table>
                </div>
                <v-divider></v-divider>
                <div
                  v-if="hasResult"
                  style="
                    width: 100%;
                    margin: 10px;
                    font-family: Arial, Helvetica, sans-serif;
                    font-size: 20x;
                  "
                >
                  <div style="width: 40%; float: left; text-align: center" >
                    <approval-result-chart
                      :approvalStatusList="votingResponse"
                      :attendees="allPermittedVoterUsers"
                      :notActedVoteCount="notActedVoteCount"
                      chartType="vote"
                      class="avoid-page-break"
                    ></approval-result-chart>
                  </div>
                  <div
                    style="
                      display: block;
                      float: left;
                      width: 60%;
                      border-left: solid 1px lightgray;
                    "
                  >
                  <h4 style="color: #000000 !important; margin: 0px 10px 10px 10px;" class="avoid-page-break">
                      {{ $t("agenda.lblApproved") }}: {{ approvedList.length }}
                    </h4>
                    <h4 style="color: #000000 !important; margin: 0px 10px 10px 10px;" class="avoid-page-break">
                      {{ $t("agenda.lblRejected") }}: {{ rejectedList.length }}
                    </h4>
                    <h4 style="color: #000000 !important; margin: 0px 10px 10px 10px;" class="avoid-page-break">
                      {{ $t("agenda.lblAbstained") }}:
                      {{ abstainedList.length }}
                    </h4>
                    <h4 style="color: #000000 !important; margin: 0px 10px 10px 10px;" class="mb-2 avoid-page-break">
                        {{ $t("agenda.lblVoteNotActed") }}:
                        {{ notActedVoteCount.length }}
                      </h4>
                  <item-approval-result-section :results="allVotingResults" section="pdf"></item-approval-result-section>
                  </div>
                  <div style="clear: both"></div>
                </div>
                <div v-if="hasResult && auditorsConsentResult">
                  <v-divider class="my-1"></v-divider>
                </div>
                <div
                  v-if="auditorsConsentResult"
                  style="
                    width: 100%;
                    margin: 10px;
                    font-family: Arial, Helvetica, sans-serif;
                    font-size: 20x;
                  "
                >
                  <div style="width: 40%; float: left; text-align: center" >
                    <approval-result-chart
                      v-if="
                        noObjectionList.length > 0 ||
                        hasObjectionList.length > 0
                      "
                      :consentStatusList="votingResponse"
                      :attendees="allPermittedConsentUsers"
                      :notActedConsentCount="notActedConsentCount"
                      chartType="consent"
                      class="avoid-page-break"
                    ></approval-result-chart>
                  </div>
                  <div
                    style="
                      display: block;
                      float: left;
                      width: 60%;
                      border-left: solid 1px lightgray;
                    "
                    >
                      <h4 style="color: #000000 !important; margin: 0px 10px 10px 10px;" class="avoid-page-break">
                      {{ $t("agenda.lblNoObjection") }}:
                      {{ noObjectionList.length }}
                    </h4>
                    <h4 style="color: #000000 !important; margin: 0px 10px 10px 10px;" class="avoid-page-break">
                      {{ $t("agenda.lblhasObjection") }}:
                      {{ hasObjectionList.length }}
                    </h4>
                    <h4 style="color: #000000 !important; margin: 0px 10px 10px 10px;" class="avoid-page-break">
                      {{ $t("agenda.lblVoteNotActed") }}:
                      {{ notActedConsentCount.length }}
                    </h4>
                  <item-approval-result-section :results="allConsentResults" section="pdf"></item-approval-result-section>
                  </div>
                  <div style="clear: both"></div>
                  <v-divider></v-divider>
                  <h4 style="margin-top: 1%" v-if="hasObjectionList.length > 0" class="avoid-page-break">
                    {{ $t("agenda.msgInvalidVotingResult") }}
                  </h4>
                </div>
              </section>
            </section>
          </vue-html2pdf>
        </v-card-text>
      </v-card>
    </a-dialog>
  </v-tooltip>
</template>
<style scoped>
.meeting-table /deep/ th {
  color: #000000de;
}
</style>
<style>
.avoid-page-break {
  page-break-inside: avoid;
}
</style>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import ApprovalResultChart from "./ApprovalResultChart.vue";
import noImage from "@/assets/images/NoPhotoIcon.png";
import ADialog from "../../wrapper-component/ADialog.vue";
import VotingUserList from "./VotingUserList.vue";
import itemApprovalResultSection from "./itemApprovalResultSection.vue";
import SignalRMixin from "../../mixin/SignalRMixin";
export default {
  name: "ApprovalResult",
  mixins: [SignalRMixin],
  components: {
    ApprovalResultChart,
    ADialog,
    VotingUserList,
    itemApprovalResultSection
  },
  data() {
    return {
      message: "",
      messageType: "",
      displayMessage: false,
      isOpen: false,
      noImage,
      votingResponse: [],
      savedScrollPosition: 0
    };
  },
  watch: {
    isOpen(value) {
      if (value) {
        this.savedScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        
        setTimeout(() => {
          const dialogContent = document.getElementById("divId");
          if (dialogContent) {
            dialogContent.scrollTop = 0;
          }
        }, 0);
      } else {
        setTimeout(() => {
          window.scrollTo(0, this.savedScrollPosition);
        }, 0);
      }
      document
        .querySelector("body")
        .classList.toggle("application--dialog-opened", value);
    },
  },
  props: {
    topicApproval: { type: Object, default: {} },
    agendaName: {
      type: String,
      default: "",
    },
    topicName: {
      type: String,
      default: false,
    },
    meetingObj: {
      type: Object,
      default: null,
    },
    topicId: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      getMeetingTypeId: "meeting/getMeetingTypeId",
    }),
    ...mapState({
      userList: (state) => state.people.userList,
      meetingVoterSummary: (state) => state.meeting.meetingVoterSummary,
    }),
    LoaderText() {
      return this.$t("LoaderText");
    },
    selectedLang() {
      return this.$i18n.locale;
    },
     selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    allAttendees(){
      return this.meetingObj.attendees
    },
    permittedUsers(){
      const allVotingUsers = this.meetingVoterSummary.map(vote => vote.permitted_users_for_voting).flat();
      const allConsentUsers = this.meetingVoterSummary.map(vote => vote.permitted_users_for_consent).flat();
      return {
        permitted_users_for_voting: new Set(allVotingUsers), // Convert to Set for better lookup
        permitted_users_for_consent: new Set(allConsentUsers)
      };
    },
    
    allPermittedVoterUsers(){
      const permittedVoters = this.permittedUsers.permitted_users_for_voting;
      const usersWithVotes = new Set(this.votingResults.map(vote => vote.userEmail));
      const attendees = this.userList.filter(attendee => {
        return usersWithVotes.has(attendee.registered_email) || permittedVoters.has(attendee.id);
      });
      return attendees;
    },
    notActedVoteCount(){
      const permittedVoters = this.permittedUsers.permitted_users_for_voting;
      const usersWithVotes = new Set(this.votingResults.map(vote => vote.userEmail));
      const notActed = this.userList.filter(attendee => {
        return !usersWithVotes.has(attendee.registered_email) && permittedVoters.has(attendee.id);
      });
      return notActed;
    },
    allPermittedConsentUsers(){
      const permittedConsents = this.permittedUsers.permitted_users_for_consent;
      const usersWithConsents = new Set(this.consentResults.map(vote => vote.userEmail));
      const attendees = this.userList.filter(attendee => {
        return usersWithConsents.has(attendee.registered_email) || permittedConsents.has(attendee.id);
      });
      return attendees;
    },
    notActedConsentCount(){
      const permittedConsents = this.permittedUsers.permitted_users_for_consent;
      const usersWithConsents = new Set(this.consentResults.map(vote => vote.userEmail));

      const notActed = this.userList.filter(attendee => {
        return !usersWithConsents.has(attendee.registered_email) && permittedConsents.has(attendee.id);
      });

      return notActed;
    },
    allVotingResults(){
      const notActed = this.notActedVoteCount.map((item) => {
        return {
            ...item,
            status: 'notacted',
            comment: ''
          };
      })
      return [...this.votingResults, ...notActed];
    },
    allConsentResults(){
      const notActed = this.notActedConsentCount.map((item) => {
        return {
            ...item,
            status: 'notacted',
            comment: ''
          };
      })
      return [...this.consentResults, ...notActed];
    },
    votingResults(){
      return this.resultsData.filter(
        (f) => f.approvalStatus === "approve" || f.approvalStatus === "reject" || f.approvalStatus === "abstain"
      ).map((item) => {
        return {
            ...item,
            status: item.approvalStatus,
            comment: item.votingComment
          };
      });
    },
    consentResults(){
      return this.resultsData.filter(
        (f) => f.consentStatus === "hasObjection" || f.consentStatus === "noObjection"
      ).map((item) => {
        return {
            ...item,
            status: item.consentStatus,
            comment: item.consentComment
          };
      });
    },
    resultsData(){
      return this.votingResponse
        .map((item) => {
          let person = this.meetingObj.attendees.find(
            (f) => f.email === item.userEmail
          );
          if (!person) {
            person = this.userList.find((u) =>
              u.contactEmailIds.includes(item.userEmail)
            );
          }
          return {
            ...item,
            profilePhoto: person ? person.profilePhoto : null,
            firstName: person ? person.firstName : "",
            lastName: person ? person.lastName : "",
            datetime: item._ts,
            createdDate: this.getUnixDateTime(item._ts),
            voting_updated_at: item.voting_updated_at ? this.getDay(item.voting_updated_at) : null,
            consent_updated_at: item.consent_updated_at ? this.getDay(item.consent_updated_at) : null,
          };
        })
        .sort(function (a, b) {
          return new Date(b.datetime) - new Date(a.datetime);
        });
    },
    hasResult() {
      return (
        Object.keys(this.votingResponse).length > 0 &&
        (this.approvedList.length > 0 ||
          this.rejectedList.length > 0 ||
          this.abstainedList.length)
      );
    },
    auditorsConsentResult() {
      return (
        Object.keys(this.votingResponse).length > 0 &&
        (this.noObjectionList.length > 0 || this.hasObjectionList.length > 0)
      );
    },

    noObjectionList() {
      let list = this.votingResponse.filter(
        (f) => f.consentStatus === "noObjection"
      );
      return list
        .map((item) => {
          let person = this.meetingObj.attendees.find(
            (f) => f.email === item.userEmail
          );
          if (!person) {
            person = this.userList.find((u) =>
              u.contactEmailIds.includes(item.userEmail)
            );
          }
          return {
            ...item,
            profilePhoto: person ? person.profilePhoto : null,
            firstName: person ? person.firstName : "",
            lastName: person ? person.lastName : "",
            datetime: item._ts,
            createdDate: this.getUnixDateTime(item._ts),
          };
        })
        .sort(function (a, b) {
          return new Date(b.datetime) - new Date(a.datetime);
        });
    },
    hasObjectionList() {
      let list = this.votingResponse.filter(
        (f) => f.consentStatus === "hasObjection"
      );
      return list
        .map((item) => {
          let person = this.meetingObj.attendees.find(
            (f) => f.email === item.userEmail
          );
          if (!person) {
            person = this.userList.find((u) =>
              u.contactEmailIds.includes(item.userEmail)
            );
          }

          return {
            ...item,
            profilePhoto: person ? person.profilePhoto : null,
            firstName: person ? person.firstName : "",
            lastName: person ? person.lastName : "",
            datetime: item._ts,
            createdDate: this.getUnixDateTime(item._ts),
          };
        })
        .sort(function (a, b) {
          return new Date(b.datetime) - new Date(a.datetime);
        });
    },
    approvedList() {
      let list = this.votingResponse.filter(
        (f) => f.approvalStatus === "approve"
      );

      return list
        .map((item) => {
          let person = this.meetingObj.attendees.find(
            (f) => f.email === item.userEmail
          );
          if (!person) {
            person = this.userList.find((u) =>
              u.contactEmailIds.includes(item.userEmail)
            );
          }

          return {
            ...item,
            profilePhoto: person ? person.profilePhoto : null,
            firstName: person ? person.firstName : "",
            lastName: person ? person.lastName : "",
            datetime: item._ts,
            createdDate: this.getUnixDateTime(item._ts),
          };
        })
        .sort(function (a, b) {
          return new Date(b.datetime) - new Date(a.datetime);
        });
    },
    rejectedList() {
      let list = this.votingResponse.filter(
        (f) => f.approvalStatus === "reject"
      );

      return list
        .map((item) => {
          let person = this.meetingObj.attendees.find(
            (f) => f.email === item.userEmail
          );
          if (!person) {
            person = this.userList.find((u) =>
              u.contactEmailIds.includes(item.userEmail)
            );
          }
          return {
            ...item,
            profilePhoto: person ? person.profilePhoto : null,
            firstName: person ? person.firstName : "",
            lastName: person ? person.lastName : "",
            datetime: item._ts,
            createdDate: this.getUnixDateTime(item._ts),
          };
        })
        .sort(function (a, b) {
          return new Date(b.datetime) - new Date(a.datetime);
        });
    },
    abstainedList() {
      // return this.topicApprovalStatusList.filter(
      //   (f) => f.approvalStatus === "abstain"
      // );

      let list = this.votingResponse.filter(
        (f) => f.approvalStatus === "abstain"
      );
      return list
        .map((item) => {
          let person = this.meetingObj.attendees.find(
            (f) => f.email === item.userEmail
          );
          if (!person) {
            person = this.userList.find((u) =>
              u.contactEmailIds.includes(item.userEmail)
            );
          }
          return {
            ...item,
            profilePhoto: person ? person.profilePhoto : null,
            firstName: person ? person.firstName : "",
            lastName: person ? person.lastName : "",
            datetime: item._ts,
            createdDate: this.getUnixDateTime(item._ts),
          };
        })
        .sort(function (a, b) {
          return new Date(b.datetime) - new Date(a.datetime);
        });
    },
    slugify() {
      return `${this.agendaName} ${this.topicName}`
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, "")
        .replace(/[\s_-]+/g, "-")
        .replace(/^-+|-+$/g, "");
    },
    updateMeetingPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "UpdateMeeting"
        );
      }
      return false;
    },
  },
  created() {
    //  this.$root.$off("refresh-meeting");
  },
  beforeDestroy() {
    this.$root.$off("refresh-meeting");
  },
  async mounted() {
    this.attendeesData = this.attendeesList;
    const targetAdminPermission = "admin_" + this.selectedTenant;
    const targetVotingTopic = "meeting_voting_" + this.meetingObj.id;
    await this.signalRTopicVoting(targetVotingTopic);
    await this.signalRAdminPermission(targetAdminPermission);
    this.$root.$on("refresh-meeting", (obj) => {
      if (this.isOpen) {
        this.getVotes();
      }
    });

  },
  methods: {
    ...mapActions({
      getMeetingTopicVote: "meeting/getMeetingTopicVote",
      getMeetingVotersSummary: "meeting/getMeetingVotersSummary",
    }),
    getMeetingName(meetingName) {
      if (meetingName.length > 200) {
        return meetingName.slice(0, 180) + "...";
      } else {
        return meetingName;
      }
    },
    signalRAdminPermission,
    signalRTopicVoting,
    scrollToTop() {
      document.getElementById("divId").scrollIntoView({
        behavior: "instant",
        block: "start",
        inline: "nearest",
      });
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    async getVotes() {
      const param = {
        meetingId: this.meetingObj.id,
        topicId: this.topicId,
      };
      try {
        const response = await this.getMeetingTopicVote(param);
        if (this.updateMeetingPermission) {
          await this.getMeetingVotersSummary(this.meetingObj.id);
        }
        this.votingResponse = response;
        this.isOpen = true;
      } catch (error) {
        console.log(error, "api error");
      }
    },
    async generateSvg() {
      await this.exportToPDF();
    },

    async exportToPDF() {
      let obj = this;
      setTimeout(function () {
        obj.$refs.html2Pdf.generatePdf();
      }, 1000);
    },
    getDay(meetingdate, ts) {
      var Xmas95 = new Date(meetingdate);
      //alert(this.selectedLang);
      var options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
      };
      return new Intl.DateTimeFormat(this.selectedLang, options).format(Xmas95);
    },
    getUnixDateTime(unix_timestamp) {
      var options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
      };
      return new Intl.DateTimeFormat(this.selectedLang, options).format(
        new Date(unix_timestamp * 1e3)
      );
    },
  },
};
async function signalRTopicVoting(target) {
  try {
    this.signalConnection.on(target, async (message) => {
      if(this.isOpen){
        const param = {
        meetingId: this.meetingObj.id,
        topicId: this.topicId,
      };
      const response = await this.getMeetingTopicVote(param);
      this.votingResponse = response;
      }
      
    });
    if (
      this.signalConnection.connectionState.toLowerCase() === "disconnected"
    ) {
      this.signalConnection.start().catch();
    }
  } catch (error) {
    console.log(error, "api error");
  }
}
async function signalRAdminPermission(target) {
  try {
    this.signalConnection.on(target, async (message) => {
      if (this.updateMeetingPermission && this.isOpen && this.meetingObj.id) {
        await this.getMeetingVotersSummary(this.meetingObj.id);
      }
    });
    if (
      this.signalConnection.connectionState.toLowerCase() === "disconnected"
    ) {
      this.signalConnection.start().catch();
    }
  } catch (error) {
    console.log(error, "api error");
  }
}
</script>
<style>
.application--dialog-opened {
  overflow: hidden;
  position: fixed;
}
.wrap-text {
  white-space: normal !important;
}
.list-avatar {
  align-self: flex-start;
}
#content {
  page-break-inside: avoid;
}
.avoid-page-break {
  page-break-inside: avoid;
}
.application--dialog-opened {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
}
</style>